import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://otpkufcdzexbvwlsmcqj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im90cGt1ZmNkemV4YnZ3bHNtY3FqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODg2ODQ3MDMsImV4cCI6MjEwNDI2MDcwM30.IMPatmP78qFW1fqE-CbIIZdDq_lh1uKiKuOSXte1XGI';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
